// src/utils/getRiskBand.ts
export type RiskBand =
  | "Cautious"
  | "Conservative"
  | "Moderate"
  | "Growth"
  | "Aggressive";

export type RiskBandInfo = {
  label: RiskBand;
  appetite: "Very Low" | "Low" | "Medium" | "High" | "Very High";
  range: [number, number]; // inclusive
  description: string;
  palette: "slate" | "teal" | "emerald" | "gold";
};

const BANDS: RiskBandInfo[] = [
  {
    label: "Cautious",
    appetite: "Very Low",
    range: [0, 20],
    description:
      "Emphasizes capital preservation and liquidity; smallest exposure to market swings.",
    palette: "slate",
  },
  {
    label: "Conservative",
    appetite: "Low",
    range: [21, 40],
    description:
      "Prioritizes stability with some growth; smoother ride over chasing higher returns.",
    palette: "teal",
  },
  {
    label: "Moderate",
    appetite: "Medium",
    range: [41, 60],
    description:
      "Balanced approach between growth and protection; accepts normal market ups and downs.",
    palette: "emerald",
  },
  {
    label: "Growth",
    appetite: "High",
    range: [61, 80],
    description:
      "Seeks long-term appreciation; comfortable with wider fluctuations to pursue returns.",
    palette: "gold",
  },
  {
    label: "Aggressive",
    appetite: "Very High",
    range: [81, 100],
    description:
      "Maximizes growth potential; accepts significant volatility and longer recovery periods.",
    palette: "gold",
  },
];

export function getRiskBand(score: number): RiskBandInfo {
  const s = Math.max(0, Math.min(100, Math.round(score)));
  for (const b of BANDS) {
    const [lo, hi] = b.range;
    if (s >= lo && s <= hi) return b;
  }
  return BANDS[0];
}
